import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-4!" }
const _hoisted_2 = { class: "flex flex-col gap-y-0.5" }
const _hoisted_3 = { class: "pr-5!" }
const _hoisted_4 = { class: "flex flex-row justify-end" }

import ReferenceTitle from '@/components/references/ReferenceTitle.vue'

interface Props {
  /** The reference item to display */
  item: ReferenceInterface
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceDatatableRow'
},
  __name: 'ReferenceDatatableRow',
  props: {
    item: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ReferenceTitle, {
          title: __props.item.title
        }, null, 8, ["title"])
      ])
    ]),
    _createElementVNode("td", null, [
      _renderSlot(_ctx.$slots, "date", {
        date: __props.item.date
      })
    ]),
    _createElementVNode("td", null, [
      _renderSlot(_ctx.$slots, "status", {
        status: __props.item.status
      })
    ]),
    _createElementVNode("td", null, [
      _renderSlot(_ctx.$slots, "badge", { item: __props.item }, () => [
        _createTextVNode(_toDisplayString(__props.item.status) + " : " + _toDisplayString(__props.item.amount?.amount), 1)
      ])
    ]),
    _createElementVNode("td", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "actions", {
          actions: __props.item.actions
        })
      ])
    ])
  ], 64))
}
}

})